import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, InputMaskModule } from 'primeng/primeng';

import { EmpregoNaPistaSharedModule } from '../shared/emprego-na-pista-shared.module';

import { Ng2BRPipesModule } from 'ng2-brpipes';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { CandidatoRouting } from './candidato.routing';

import { CandidatoService } from './candidato.service';
import { InscricaoService } from '../../services/inscricao.service';

import { ConsultarConvocacaoComponent } from './consultar-convocacao/consultar-convocacao.component';
import { InscricaoEditFormComponent } from './inscricao-edit-form/inscricao-edit-form.component';
import { InscricaoFormComponent } from './inscricao-form/inscricao-form.component';
import { ReagendarCandidatoComponent } from './reagendar-candidato/reagendar-candidato.component';
import { RelatorioInscritosComponent } from './relatorio-inscritos/relatorio-inscritos.component';
import { RelatorioIntegracaoDetranComponent } from './relatorio-integracao-detran/relatorio-integracao-detran.component';
import { TermoAceiteComponent } from './termo-aceite/termo-aceite.component';
import { ValidaDadosComponent } from './valida-dados/valida-dados.component';
import { VisualizarCandidatoComponent } from './visualizar-candidato/visualizar-candidato.component';
import { VisualizarHistoricoComponent } from './visualizar-historico/visualizar-historico.component';
import { AlterarArquivoComponent } from './alterar-arquivo/alterar-arquivo.component';
import { InserirDocumentosAssinadosComponent } from './inserir-documentos-assinados/inserir-documentos-assinados.component';
import { DocumentoAssinadoService } from '../shared/services/documento-assinado.service';
import { GerenciarStatusAlunoComponent } from './gerenciar-status-aluno/gerenciar-status-aluno.component';
import { EditarCandidatoComponent } from './editar-candidato/editar-candidato.component';
import { EnviarTermoAditivoComponent } from './enviar-termo-aditivo/enviar-termo-aditivo.component';
import { VisualizarTermoAditivoGeradoComponent } from './visualizar-termo-aditivo-gerado/visualizar-termo-aditivo-gerado.component';
import { ArquivosGeraisCandidatoComponent } from './arquivos-gerais-candidato/arquivos-gerais-candidato.component';
import { InserirArquivoGeralCandidatoComponent } from './inserir-arquivo-geral-candidato/inserir-arquivo-geral-candidato.component';
import { AceiteTermosLGPDComponent } from "./termos-lgpd/aceite-termos-lgpd.component";
import { LgpdService } from "../../services/lgpd.service";
import { AnalisarDocumentosCandidatoComponent } from './analisar-documentos-candidato/analisar-documentos-candidato.component';
@NgModule({
    imports: [
        BrowserModule,
        FormsModule, ReactiveFormsModule,

        CandidatoRouting,

        ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, InputMaskModule,

        Ng2BRPipesModule,
        CurrencyMaskModule,

        EmpregoNaPistaSharedModule
    ],
    providers: [ CandidatoService, InscricaoService,LgpdService, DocumentoAssinadoService ],
    declarations: [
        ConsultarConvocacaoComponent,
        InscricaoEditFormComponent,
        InscricaoFormComponent,
        ReagendarCandidatoComponent,
        RelatorioInscritosComponent,
        RelatorioIntegracaoDetranComponent,
        TermoAceiteComponent,
        ValidaDadosComponent,
        VisualizarCandidatoComponent,
        VisualizarHistoricoComponent,
        AlterarArquivoComponent,
        InserirDocumentosAssinadosComponent,
        GerenciarStatusAlunoComponent,
        EditarCandidatoComponent,
        EnviarTermoAditivoComponent,
        VisualizarTermoAditivoGeradoComponent,
        ArquivosGeraisCandidatoComponent,
        InserirArquivoGeralCandidatoComponent,
        AceiteTermosLGPDComponent,
        AnalisarDocumentosCandidatoComponent
    ],
})
export class CandidatoModule { }



// WEBPACK FOOTER //
// ./src/app/components/candidato/candidato.module.ts